module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[46]411.fec7d5a.woff2";